import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../api/client';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    setError('');
    try {
      await apiClient.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
        <Card sx={{ width: 400 }}>
          <CardContent sx={{ p: 4 }}>
            <Alert severity="error">Invalid reset link. Please request a new one.</Alert>
            <Button component={Link} to="/forgot-password" fullWidth sx={{ mt: 3 }}>Request reset link</Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ width: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" fontWeight={700} mb={3}>Set new password</Typography>

          {done ? (
            <>
              <Alert severity="success">Password updated successfully.</Alert>
              <Button component={Link} to="/login" variant="contained" fullWidth sx={{ mt: 3 }}>
                Sign in
              </Button>
            </>
          ) : (
            <>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label="New password" type="password" size="small"
                  value={password} onChange={e => setPassword(e.target.value)}
                  required autoFocus inputProps={{ minLength: 8 }}
                />
                <TextField
                  label="Confirm password" type="password" size="small"
                  value={confirm} onChange={e => setConfirm(e.target.value)} required
                />
                <Button type="submit" variant="contained" disabled={loading}>
                  {loading ? 'Saving…' : 'Set password'}
                </Button>
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
